export const formatMinAndSeconds = (seconds: number) => {
  const min = Math.floor(Math.abs(seconds) / 60)
  const sec = Math.abs(seconds) % 60
  return `${seconds < 0 ? '-' : ''}${min}:${sec.toString().padStart(2, '0')}`
}
